<template>
  <router-view/>
</template>

<script>
  import RouteEntryMixin from '@com/mixins/route-entry'

  export default {
    name: 'trade',
    mixins: [RouteEntryMixin],
    data: _ => ({
      routes: [
        { path: '/trade/make', label: 'Trade' }
      ]
    })
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/app/trade/Trade.Entry.vue